
import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

const DispensingPage = () => {
  const handleHomeClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <SEOHead 
        title="調剤業務 - 相談できる薬局 一心堂薬局"
        description="処方箋に基づく調剤・服薬指導を行っています。"
      />
      
      <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
        {/* Navigation */}
        <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50">
          <div className="max-w-md mx-auto px-4 py-3">
            <div className="flex items-center justify-between">
              <Link to="/" onClick={handleHomeClick} className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center">
                  <i className="ri-leaf-fill text-white text-sm"></i>
                </div>
                <span className="font-bold text-green-800" style={{fontFamily: 'Pacifico, serif'}}>
                  相談できる薬局 一心堂薬局
                </span>
              </Link>
              <Link to="/" onClick={handleHomeClick} className="w-8 h-8 flex items-center justify-center">
                <i className="ri-close-line text-green-800 text-xl"></i>
              </Link>
            </div>
          </div>
        </nav>

        {/* Content */}
        <div className="pt-20 pb-24 px-4">
          <div className="max-w-md mx-auto">
            {/* Header */}
            <div className="text-center mb-8">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/0f4ff90120649b863c73d20a7bccddb8.jpg"
                  alt="調剤業務"
                  className="w-full h-full object-cover"
                />
              </div>
              <h1 className="text-2xl font-bold text-green-800 mb-2">調剤業務</h1>
              <p className="text-gray-600">処方箋に基づく調剤・服薬指導</p>
            </div>

            {/* Services */}
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-green-100">
                <h2 className="text-lg font-semibold text-green-800 mb-4">処方箋調剤</h2>
                <p className="text-gray-600 mb-4">
                  医師の処方箋に基づき、正確で安全な調剤を行います。お薬の効果や副作用について丁寧にご説明いたします。
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    処方箋の内容確認
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    薬歴管理・相互作用チェック
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    正確な調剤・監査
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-green-100">
                <h2 className="text-lg font-semibold text-green-800 mb-4">服薬指導</h2>
                <p className="text-gray-600 mb-4">
                  お薬の正しい飲み方や注意点について、わかりやすくご説明いたします。
                </p>
                <ul className="space-y-2 text-sm text-gray-600">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    服用方法・タイミングの説明
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    副作用・注意事項の説明
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-600 mr-2"></i>
                    生活習慣のアドバイス
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-green-100">
                <h2 className="text-lg font-semibold text-green-800 mb-4">お薬手帳管理</h2>
                <p className="text-gray-600 mb-4">
                  お薬手帳の記録管理を通じて、安全で効果的な薬物療法をサポートします。
                </p>
                <div className="text-center mt-6">
                  <a 
                    href="tel:0479-70-6065" 
                    className="inline-flex items-center bg-green-600 text-white py-3 px-6 rounded-full font-medium text-sm hover:bg-green-700 transition-colors"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    電話
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-6 text-center">
              <Link 
                to="/"
                onClick={handleHomeClick}
                className="inline-block bg-blue-600 text-white py-3 px-8 rounded-full font-medium text-sm"
              >
                <i className="ri-home-line mr-2"></i>
                ホームへ
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Navigation */}
        <nav className="fixed bottom-0 w-full bg-white border-t border-gray-200 z-50">
          <div className="max-w-md mx-auto">
            <div className="grid grid-cols-5 py-2">
              <Link to="/" onClick={handleHomeClick} className="flex flex-col items-center justify-center py-2 text-gray-400">
                <i className="ri-home-5-line text-lg"></i>
                <span className="text-xs mt-1">ホーム</span>
              </Link>
              <button className="flex flex-col items-center justify-center py-2 text-blue-600">
                <i className="ri-medicine-bottle-fill text-lg"></i>
                <span className="text-xs mt-1">調剤</span>
              </button>
              <button className="flex flex-col items-center justify-center py-2 text-gray-400">
                <i className="ri-leaf-line text-lg"></i>
                <span className="text-xs mt-1">漢方相談</span>
              </button>
              <button className="flex flex-col items-center justify-center py-2 text-gray-400">
                <i className="ri-map-pin-line text-lg"></i>
                <span className="text-xs mt-1">アクセス</span>
              </button>
              <a href="tel:0479-70-6065" className="flex flex-col items-center justify-center py-2 text-gray-400">
                <i className="ri-phone-line text-lg"></i>
                <span className="text-xs mt-1">お問合せ</span>
              </a>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default DispensingPage;
